import createReducer from 'arts/config/create_reducer';
import Constants from 'arts/config/constants';
import { toCamelCase } from '../../wall_builder/config/utils';

const getDefaultState = () => ({
  loading: false,
  items: toCamelCase(window.gifts_guides || [])
});

export default createReducer(getDefaultState(), {
  [Constants.GiftGuides.LOAD]: () => ({
    ...getDefaultState(),
    loading: true
  }),
  [Constants.GiftGuides.LOADED]: (_, { items }) => ({
    loading: false,
    items
  })
});
